export default {
  active: 'ACTIVE',
  suspended: 'SUSPENDED',
  pending: 'PENDING',
}
